import React from 'react';

export const Blog = () => (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 20px' }}>
        <h1>Learning Hub</h1>
        <p>Latest articles on communication mastery.</p>
        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px', marginTop: '20px' }}>
            <h3>5 Tips to Reduce Pauses</h3>
            <p>Read about the science of "filler words" and how to eliminate them...</p>
        </div>
    </div>
);

export const FAQ = () => (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 20px' }}>
        <h1>Frequently Asked Questions</h1>

        <div style={{ marginBottom: '20px' }}>
            <h3>Do you offer certificates?</h3>
            <p>Yes, all paid courses come with a course completion certificate.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
            <h3>Can I access on mobile?</h3>
            <p>Absolutely. Our platform is fully responsive.</p>
        </div>
    </div>
);

export const Docs = () => (
    <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '60px 20px' }}>
        <h1 style={{ fontSize: '2.2rem', marginBottom: '12px' }}>Documentation Center</h1>
        <p style={{ color: '#4b5563', marginBottom: '28px' }}>
            Everything you need to set up, use, and integrate ARIVUNEST.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '18px' }}>
            <section style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px' }}>
                <h3 style={{ marginTop: 0 }}>Setup Guide</h3>
                <p style={{ color: '#4b5563' }}>
                    Install dependencies, configure environment variables, run backend/frontend, and verify services.
                </p>
                <ul style={{ color: '#374151', paddingLeft: '18px' }}>
                    <li>Backend: FastAPI + SQLAlchemy</li>
                    <li>Frontend: React + Firebase Auth</li>
                    <li>Local URLs and environment setup</li>
                </ul>
            </section>

            <section style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px' }}>
                <h3 style={{ marginTop: 0 }}>API Docs</h3>
                <p style={{ color: '#4b5563' }}>
                    Explore auth, courses, learning, notifications, instructor, and admin endpoints.
                </p>
                <ul style={{ color: '#374151', paddingLeft: '18px' }}>
                    <li>OpenAPI 3.0 / Swagger Interactive Specs</li>
                    <li>JWT auth and role-based access</li>
                    <li>Request/response examples</li>
                </ul>
            </section>

            <section style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px' }}>
                <h3 style={{ marginTop: 0 }}>User Guide</h3>
                <p style={{ color: '#4b5563' }}>
                    Portal walkthrough for students, instructors, and admins.
                </p>
                <ul style={{ color: '#374151', paddingLeft: '18px' }}>
                    <li>Student learning workflow</li>
                    <li>Instructor course management</li>
                    <li>Admin controls and moderation</li>
                </ul>
            </section>
        </div>
    </div>
);
